import { create } from 'zustand';
import { Skill } from '../types';
import { apiService } from '../services/api';
import { toast } from 'react-hot-toast';

interface SkillsState {
  skills: Skill[];
  isLoading: boolean;
  error: string | null;
}

interface SkillsActions {
  fetchSkills: () => Promise<void>;
  getSkillById: (skillId: string) => Skill | undefined;
  getDefaultSkill: () => Skill | undefined;
  clearError: () => void;
}

type SkillsStore = SkillsState & SkillsActions;

export const useSkillsStore = create<SkillsStore>((set, get) => ({
  // Initial state
  skills: [],
  isLoading: false,
  error: null,

  // Fetch skills from API
  fetchSkills: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await apiService.getSkills();
      set({ skills: response.skills, isLoading: false });
    } catch (error: any) {
      const message = error.response?.data?.message || 'Failed to load skills';
      set({ error: message, isLoading: false });
      console.error('Failed to fetch skills:', error);
      // Don't show toast for initial load failures - just log
    }
  },

  // Get skill by ID
  getSkillById: (skillId: string) => {
    return get().skills.find(s => s.skill_id === skillId);
  },

  // Get default skill
  getDefaultSkill: () => {
    return get().skills.find(s => s.is_default) || get().skills[0];
  },

  // Clear error
  clearError: () => set({ error: null }),
}));
